import { lazy } from 'react';

const LazyClientSpaceListView = lazy(() => import('./client-space-list-view'));
export default LazyClientSpaceListView;
